import { createFileRoute } from "@tanstack/react-router";
import Tractoare from "@/pages/Tractoare";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/tractoare/")({
  head: () => routeHead("/tractoare/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Tractoare />
  );
}
